<div class="my-3">
  @if (mzTabResult | async; as result) {
    <app-dataset-card [mzTabResult]="result" [detailView]="true" [showPlots]="true" [showClassifications]="true"></app-dataset-card>
  } @else {
    <app-error-card
      title="Dataset not available"
      subheader="We could not load the requested dataset"
      [message]="errorMessage"
      feedbackLabel="Contact us"
      [dismissRoute]="['/dataset']"
    ></app-error-card> 
  }
</div>
